import { render, staticRenderFns } from "./organisationUnit.vue?vue&type=template&id=ed34a808&scoped=true&"
import script from "./organisationUnit.vue?vue&type=script&lang=js&"
export * from "./organisationUnit.vue?vue&type=script&lang=js&"
import style0 from "./organisationUnit.vue?vue&type=style&index=0&id=ed34a808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed34a808",
  null
  
)

export default component.exports